// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchGroup } from '../../services/GroupsService';
import { Group, PatchGroupRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, PatchGroupRequest>;

function usePatchGroup(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchGroup, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['groups'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchGroup;
